export default __webpack_public_path__ + "static/media/con-online.0fbfa795.svg";